"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateProductImplementation = void 0;
const common_1 = require("../../common");
class UpdateProductImplementation extends common_1.UpdateAction {
}
exports.UpdateProductImplementation = UpdateProductImplementation;
//# sourceMappingURL=update-product-implementation.action.js.map